import FilterAttributeMethodsTypes from '@fr/vue/components/filters/common/filterMethods/filterAttributeMethodsHotelArray/FilterAttributeMethodsHotelArray';
import dataWaterActivities from './dataWaterActivites';
import { IWaterActivities } from '.';

const filterAttributeMethodsWaterActivities = new FilterAttributeMethodsTypes<IWaterActivities>(dataWaterActivities, 'waterActivities').setFilterName('Водные развлечения');

export default filterAttributeMethodsWaterActivities;